define('score_bootstrap/Models/Search/FacetRangePanel',[
    "jquery",
    "knockout",
    "bootstrapslider"
], function ($, ko, bootstrapslider) {
    "use strict";

    var searchLogic = [ "and", "or" ];

    function FacetRangeValue(preselectedValue, rowElement, initValue) {

        var self = this;
        this.rowElement = rowElement;

        preselectedValue =  preselectedValue || initValue;
        this.initValue = ko.observable("[" + preselectedValue + "]");

        this.selectedRange = ko.observable(preselectedValue || initValue);

        ko.applyBindings(this, rowElement);

        $(rowElement).show();
        $(rowElement).slider({});
        $(rowElement).on("slideStop", function(slider) {
            self.selectedRange(slider.value.join(","));
        });
    }

    function FacetRangePanel(panelElement, allPreselected) {
        var $dataEl = $(".js-facet", panelElement),
            title = $dataEl.attr("data-title"),
            searchLogicType = $dataEl.attr("data-search-logic-type").toLowerCase(),
            initMinValue = $dataEl.attr("data-min-value"),
            initMaxValue = $dataEl.attr("data-max-value"),
            indexFieldName = $dataEl.attr("data-index-field-name"),
            initValue = initMinValue + "," + initMaxValue,
            id = $dataEl.attr("data-id");

        var $rangeSlider = $("input.score-facet-range", panelElement);
        var preselected = allPreselected && allPreselected[title] ? allPreselected[title][0] : null;
        var rangeValue = new FacetRangeValue(preselected, $rangeSlider[0], initValue);

        Object.defineProperties(this, {
            id: {
                value: id                
            },
            title: {
                value: title
            },
            searchLogicType: {
                value: searchLogic.indexOf(searchLogicType)
            },
            rangeFacet: {
                get: function() {
                    return rangeValue.selectedRange() !== initValue ? rangeValue.selectedRange() : null;
                }
            },
            indexFieldName: {
                get: function() {
                    return indexFieldName;
                }
            },
            asString: {
                get: function () {
                    var result = rangeValue.selectedRange();

                    return result && (result !== initValue) ? (this.title + ":" + result) : null;
                }
            }
        });

        this.selectValues = function (selectedValues) {
            var newValue = selectedValues && selectedValues[title] ? selectedValues[title][0] : null;
            var oldValue = rangeValue.selectedRange();
            if (oldValue !== newValue) {
                newValue = newValue || initValue;
                rangeValue.selectedRange(newValue);
                $(rangeValue.rowElement).slider("setValue", newValue.split(",").map(Number));
            }
        };

        this.unselectAll = function unselectAll() {
            $rangeSlider.slider('setValue', [parseInt(initMinValue, 10), parseInt(initMaxValue, 10)], true, true);
            rangeValue.selectedRange(initValue);
        };
    }

    return FacetRangePanel;
});
